import apiFetch from '../apiFetch'

export default function (value) {
  return apiFetch({endPoint: `Recta/getRecta?idRecta=` + value, method: 'GET', body: null})
}
